
// TextControlView.js
import eventBus        from 'EventBus';
import BaseControlView from 'BaseControlView';
import contentTemplate from 'common-visuals/control-text.ejs';
import constants        from "Constants";
//=====================================================================
//
// An instance of this view represents one of five possible kinds 
// of text controls.
//
// Lou Mauget, November 2015
//
//=====================================================================
class TextControlView extends BaseControlView  {

        initialize( opts ) {
            super.initialize( opts );

            this.template = contentTemplate;
            this.tagName = 'div';
            this.propViews = opts.propViews;

            this.listenTo(this.model, 'change', this.render);
            this.listenTo( eventBus, 'textThemeChange', this.themeChangeRender);
            this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
            return this;
        }

        // Neighbor aligner uses this polymorphic property, looking for
        // value 'BaseStaticTextControl'
        get kind() {
            return 'BaseStaticTextControl';
        }


}

export default TextControlView;
